import React, { useState, useEffect } from 'react'
import { useQueryParams } from 'raviger'

import { colors } from 'Constants'
import { getReport, getReportLevel } from '../helpers'
import { sortReportsByAlerts } from 'Helpers'

import { Flex } from 'lese'
import ScaleLoader from 'react-spinners/ScaleLoader'
import ReportTitle from '../components/ReportTitle'
import ReportHeader from '../components/ReportHeader'
import AlertReport from './components/AlertReport'

import { useStore } from 'laco-react'
import { ReportSortingStore } from 'Store'

export default ({ appCode }) => {
  const reportSortingState = useStore(ReportSortingStore)
  const [
    { startDate, endDate, officeId, patientRef, showArchivedOffices },
    setQuery
  ] = useQueryParams()
  const [reports, setReports] = useState([])
  const [loading, setLoading] = useState(true)

  const title = getReportLevel(officeId, patientRef)

  useEffect(async () => {
    setReports(
      await getReport('/reports/alert/get', {
        appCode,
        startDate,
        endDate,
        officeId,
        patientRef,
        showArchivedOffices
      }).then(reports =>
        sortReportsByAlerts(reports).map(report => {
          report.alerts = report.alerts.map((row, i) => {
            row.id = i
            return row
          })
          return report
        })
      )
    )
    setLoading(false)
  }, [])

  return (
    <>
      <ReportTitle
        title={`${title} Alert Report`}
        csvUrl="/reports/alert/csv"
        csvPayload={reportSortingState}
        appCode={appCode}
      />
      {loading && (
        <Flex xAlign yAlign height="70vh">
          <ScaleLoader color={colors.secondary} loading={loading} />
        </Flex>
      )}
      {reports.map(report => (
        <>
          <ReportHeader
            header="Office"
            title={report.title}
            cardValues={[
              ['Total', 'Responses', report.total],
              ['Total', 'Alerts', report.alerts.length],
              ['Total', 'Patients', report.totalPatients]
            ]}
          />
          <AlertReport report={report} />
        </>
      ))}
    </>
  )
}
